module.exports = __webpack_public_path__ + "img/nav-profile-icon.56f8a891.svg";